import { DSColor, Palette } from '@ppwr/poker'

export const getDSColorWithOpacity = (color: DSColor, opacity: number) => {
  const opacityHex = Math.round(opacity * 255)
    .toString(16)
    .padStart(2, '0')
    .toUpperCase()
  return `${Palette[color]}${opacityHex}`
}
